import CheckoutAvailabilityNotice from '../utils/CheckoutAvailabilityNotice';
import React, { Component } from 'react';
import CartMessages from '../utils/CartMessages';
import PromotionBenefits from '../utils/PromotionBenefits';
import {RewardOffers} from '../utils/RewardProduct';
import OrganicDivider from '../utils/OrganicDivider';
import './CartTheme.css';
import { addressApi, cartApi, getBrowserCountryCode, setGuestCartId, storefrontApi } from '../../api/Api';
import { Link } from 'react-router-dom';
import store, { CART_COUNT_UPDATE } from '../../utils/store';
import { removecart } from '../../utils/byoscart';
import {clearCheckoutPromo} from '../../utils/checkoutPromo';
import {rewardCartKey} from '../../utils/rewardSelection';
import {groupProductOffers,rewardQuoteFor} from '../../utils/groupProductOffers';

import { NotificationContainer, NotificationManager } from 'react-notifications';


class Cart extends Component {

    constructor(props) {
        super(props);
        this.state = {
            cartCountryId: null,
            wishlist:[],
            totalBox:[],
            messagesUpdating: false,
            serviceCheck:false,
            addressLoaded: false,
            defaultAddress: null,
            rewardSelections: {},
        }
    }

    componentDidMount() {
        this.cartUnmounted = false;
        this.loadCart();
        this.loadDefaultAddress();
    }

    componentWillUnmount() {
        this.cartUnmounted = true;
    }

    selectReward = (promotionId, rewardId) => {
        if (this.state.messagesUpdating || !Number.isInteger(rewardId) || rewardId < 0) return;
        return this.priceRewards({...this.state.rewardSelections, [promotionId]: rewardId});
    };

    async priceRewards(selections, items = this.state.wishlist) {
        const owner = localStorage.getItem('natureway_token');
        const cartId = localStorage.getItem('natureway_guest_cart_id');
        this.setState({messagesUpdating:true});
        try {
            const response = await cartApi.pricing({
                country_id: Number(localStorage.getItem('country_id') || this.state.cartCountryId) || undefined,
                items: items.map(item => ({product_id:Number(item.product_id), product_sku_id:Number(item.product_sku_id), quantity:Number(item.quantity)})),
                reward_selections: selections,
            });
            if (this.cartUnmounted || owner !== localStorage.getItem('natureway_token') || cartId !== localStorage.getItem('natureway_guest_cart_id')) return;
            const quote = response.data?.data;
            if (response.data?.status !== 'success' || !quote || !Number.isFinite(Number(quote.total)) || quote.total == null) {
                throw new Error(response.data?.message || 'Unable to update your reward. Please try again.');
            }
            const paidLines = (quote.items || []).filter(line => !line.is_reward);
            this.setState({rewardSelections:selections, promotionQuote:quote, wishlist:items.map(item => {
                const line = paidLines.find(line => Number(line.product_sku_id) === Number(item.product_sku_id));
                return line ? {...item, offer_unit_price:line.offer_unit_price, line_total:line.line_total, total_price:line.line_total, offer:line.offer, applied_promotions:line.applied_promotions} : item;
            }), totalBox:{
                ...this.state.totalBox, sub_total_cart_value:quote.mrp_subtotal,
                total_discount:Number(quote.mrp_subtotal) - Number(quote.total), total_cart_value:quote.total,
            }});
        } catch (error) {
            if (!this.cartUnmounted) NotificationManager.error(error.response?.data?.message || error.message || 'Unable to update your reward. Please try again.');
        } finally {
            if (!this.cartUnmounted) this.setState({messagesUpdating:false});
        }
    }

    isDefaultAddress(address = {}) {
        return address.is_default === true
            || address.is_default === 1
            || address.is_default === '1'
            || address.is_default === 'true';
    }

    async loadDefaultAddress() {
        const token = localStorage.getItem('natureway_token');
        if (!token) {
            this.setState({ addressLoaded: true });
            return;
        }

        try {
            const response = await addressApi.list();
            const payload = response.data || {};
            const addresses = Array.isArray(payload.data) ? payload.data : [];
            const defaultAddress = addresses.find((address) => this.isDefaultAddress(address)) || null;
            this.setState({ defaultAddress, addressLoaded: true });
        } catch (error) {
            console.error(error);
            this.setState({ addressLoaded: true });
        }
    }

    async loadCart() {
        this.setState({ messagesUpdating: true });
        try {
          // Resolve the numeric country ID from the same country-code based
          // storefront request used by the home page before loading the cart.
          try {
              await storefrontApi.getHome();
          } catch (error) {
              console.error(error);
          }
          const response = await cartApi.detail({
              country_id: localStorage.getItem('country_id') || undefined,
          });
          let resVal = response.data;
            if(resVal.status==='success'){
                setGuestCartId(resVal.guest_cart_id);
                if (Array.isArray(resVal.data) && resVal.data.length === 0) clearCheckoutPromo();
                store.dispatch({ type: CART_COUNT_UPDATE, value: resVal.cartCount || 0 });
                await new Promise(resolve => this.setState({cartCountryId: resVal.country_id, wishlist:Array.isArray(resVal.data) ? resVal.data : [], totalBox:resVal.totalAmount || {}, promotionQuote:resVal.promotion_quote || null, serviceCheck:true, ...(!resVal.data?.length ? {rewardSelections:{}} : {})}, resolve));
                if (resVal.data?.length && Object.keys(this.state.rewardSelections).length) await this.priceRewards(this.state.rewardSelections, resVal.data);
            }else{
                this.setState({wishlist:[], totalBox:{}, serviceCheck:true});
            }
        } catch (error) {
            this.setState({serviceCheck:true});
            console.error(error);
        }
        finally {
            this.setState({ messagesUpdating: false });
        }
    }

    getCartAmountBeforeShipping(totalBox = this.state.totalBox) {
        return Number(totalBox.total_cart_value ?? totalBox.sub_total_cart_value ?? 0);
    }

    async localremovewishlist(cart_id) {
        this.setState({ messagesUpdating: true });
        await removecart(cart_id);
        await this.loadCart();
    }

    async updateCart(typeVal, cart_id, quantity = 0) {
        if (this.quantityRequestPending) return;
        const previousItems = this.state.wishlist;
        const item = previousItems.find(product => product.cart_id === cart_id);
        if (!item) return;
        const nextQuantity = typeVal === 'I' ? Number(item.quantity) + 1
            : typeVal === 'D' ? Number(item.quantity) - 1 : quantity;
        this.quantityRequestPending = true;
        this.setState({
            messagesUpdating: true,
            wishlist: previousItems.map(product => product.cart_id === cart_id
                ? { ...product, quantity: nextQuantity } : product),
        });
        try {
            const response = await cartApi.updateItem(cart_id, {
                type: typeVal,
                quantity,
                country_id: localStorage.getItem('country_id') || undefined,
            });
            const result = response.data;
            if (result.status !== 'success' || !Array.isArray(result.data) || !result.totalAmount) {
                throw new Error(result.message || 'Unable to update quantity. Please try again.');
            }
            setGuestCartId(result.guest_cart_id);
            if (result.data.length === 0) clearCheckoutPromo();
            store.dispatch({ type: CART_COUNT_UPDATE, value: result.cartCount || 0 });
            await new Promise(resolve => this.setState({ wishlist: result.data, totalBox: result.totalAmount, cartCountryId: result.country_id, promotionQuote:result.promotion_quote || null, ...(!result.data.length ? {rewardSelections:{}} : {}) }, resolve));
            if (result.data.length && Object.keys(this.state.rewardSelections).length) await this.priceRewards(this.state.rewardSelections, result.data);
            const updatedItem = result.data.find(product => product.cart_id === cart_id);
            if (updatedItem && Number(updatedItem.quantity) !== nextQuantity) {
                NotificationManager.info('Quantity adjusted to available stock.');
            }
        } catch (error) {
            this.setState({ wishlist: previousItems });
            NotificationManager.error(error.response?.data?.message || error.message
                || 'Unable to update quantity. Please try again.');
        } finally {
            this.quantityRequestPending = false;
            this.setState({ messagesUpdating: false });
        }
    }

    renderCartMessages() {
        if (!localStorage.getItem('natureway_token') || !this.state.addressLoaded) {
            return null;
        }

        const defaultAddress = this.state.defaultAddress || {};
        return <CartMessages
            placement="cart"
            countryCode={getBrowserCountryCode()}
            stateId={defaultAddress.state_id || defaultAddress.shipping_state_id || defaultAddress.user_state_id || null}
            items={this.state.messagesUpdating ? [] : this.state.promotionQuote?.items || this.state.wishlist}
            subtotal={this.getCartAmountBeforeShipping()}
            refreshKey={JSON.stringify([localStorage.getItem('natureway_token'), defaultAddress, this.state.totalBox])}
        />;
    }

    renderLoadingState() {
        return (
            <div className="ps-cart-page nw-cart nw-cart--loading" role="status" aria-label="Loading cart" aria-busy="true">
                <div className="container ps-cart-shell__container" aria-hidden="true">
                    <span className="nw-cart-skeleton nw-cart-skeleton--crumb" />
                    <div className="nw-cart-skeleton-heading">
                        <span className="nw-cart-skeleton nw-cart-skeleton--title" />
                        <span className="nw-cart-skeleton nw-cart-skeleton--copy" />
                    </div>
                    <div className="ps-cart__layout">
                        <div className="nw-cart-skeleton-list">
                            {[0, 1, 2].map((item) => <div className="nw-cart-skeleton-item" key={item}>
                                <span className="nw-cart-skeleton nw-cart-skeleton--image" />
                                <div><span className="nw-cart-skeleton nw-cart-skeleton--copy" /><span className="nw-cart-skeleton nw-cart-skeleton--short" /></div>
                                <span className="nw-cart-skeleton nw-cart-skeleton--quantity" />
                            </div>)}
                        </div>
                        <div className="nw-cart-skeleton-summary">
                            <span className="nw-cart-skeleton nw-cart-skeleton--title" />
                            {[0, 1, 2, 3].map((row) => <span className="nw-cart-skeleton nw-cart-skeleton--copy" key={row} />)}
                            <span className="nw-cart-skeleton nw-cart-skeleton--button" />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const cartItems = Array.isArray(this.state.wishlist) ? this.state.wishlist : [];
        const totalBox = this.state.totalBox || {};
        const {groups:productGroups,unassigned} = groupProductOffers(cartItems,this.state.promotionQuote);
        const groupedIds = new Set(productGroups.flatMap(group=>group.promotionIds));
        const remainingNotices = this.state.promotionQuote ? {...this.state.promotionQuote,
            reward_items:[], reward_choices:[],
            messages:this.state.promotionQuote.messages?.filter(message=>!groupedIds.has(String(message.promotion_id))),
            blockers:this.state.promotionQuote.blockers?.filter(blocker=>blocker !== 'reward_selection_required' || unassigned.length > 0),
        } : null;
        const grandTotal = this.getCartAmountBeforeShipping();
        const itemCount = cartItems.reduce((count, item) => count + (Number(item.quantity) || 0), 0);
        const getProductLink = (product) => product.product_slug
            ? `/product/${encodeURIComponent(product.product_slug)}`
            : `/product/${encodeURIComponent(String(product.variation_id || product.product_id || product.product_name || 'product'))}`;
        const getVariantDetails = (product) => Array.isArray(product.variant_details) && product.variant_details.length > 0
            ? product.variant_details
            : [];
        const money = (value) => Number(value || 0).toFixed(2);
        if(this.state.serviceCheck===false) {
            return this.renderLoadingState();
        }

        return (
            <div className="ps-cart-page ps-cart-page--clean nw-cart">
                <div className="container"><CheckoutAvailabilityNotice /></div>
                <div className="ps-categogy ps-categogy--separate ps-cart-shell">
                    <div className="container whiteContainer ps-cart-shell__container">
                        <nav aria-label="Breadcrumb"><ul className="ps-breadcrumb">
                            <li className="ps-breadcrumb__item"><Link to="/">Home</Link></li>
                            <li className="ps-breadcrumb__item active" aria-current="page">Cart</li>
                        </ul></nav>

                        {cartItems.length > 0 ? (
                            <div className="ps-cart__header">
                                <div className="ps-cart__headerCopy">
                                    <h1>Your shopping <span>cart</span></h1>
                                    <OrganicDivider />
                                    <p>Review your favourites before checkout.</p>
                                </div>
                                <ol className="nw-cart__steps" aria-label="Checkout progress">
                                    <li aria-current="step"><span>1</span>Your cart</li>
                                    <li><span>2</span>Checkout</li>
                                </ol>
                            </div>
                        ) : null}

                        {cartItems.length > 0 ? (
                            <div className="ps-cart__layout" aria-busy={this.state.messagesUpdating}>
                                <section className="ps-cart-list" aria-label="Cart items">
                                    <div className="nw-cart__list-title"><h2>Your selection</h2><span>{itemCount} {itemCount === 1 ? 'item' : 'items'}</span></div>
                                    <div className="ps-cart-list__head" aria-hidden="true">
                                        <span>Product</span>
                                        <span>Price</span>
                                        <span>Quantity</span>
                                        <span>Total</span>
                                        <span></span>
                                    </div>
                                    {productGroups.map((group,groupIndex) => <section className={`nw-cart-product-group${group.promotionIds.length ? ' nw-cart-product-group--offer' : ''}`} aria-label={`Product group: ${group.items.map(item=>item.product_name).join(', ')}`} key={group.items.map(item=>item.cart_id || item.product_sku_id).join('-') || groupIndex}>
                                    {group.items.map((product_details, index) => (
                                        <article className="ps-cart-item" key={`${product_details.cart_id || product_details.variation_id || index}-${index}`}>
                                            <div className="ps-cart-item__product">
                                                <Link
                                                    className="ps-cart-item__image"
                                                    to={getProductLink(product_details)}
                                                >
                                                    {product_details.display_image ? (
                                                        <figure>
                                                            <img src={product_details.display_image} alt={product_details.product_name} loading="lazy" onError={(event) => {
                                                                if (!event.currentTarget.src.endsWith('/assets/img/logo-no-image.png')) event.currentTarget.src = '/assets/img/logo-no-image.png';
                                                            }} />
                                                        </figure>
                                                    ) : (
                                                        <figure>
                                                            <img src='/assets/img/logo-no-image.png' alt="No product" />
                                                        </figure>
                                                    )}
                                                </Link>

                                                <div className="ps-cart-item__content">
                                                    <Link
                                                        className="ps-cart-item__title"
                                                        to={getProductLink(product_details)}
                                                    >
                                                        {product_details.product_name}
                                                    </Link>
                                                    {getVariantDetails(product_details).length > 0 ? (
                                                        <Link className="ps-cart-item__variants" to={getProductLink(product_details)}>
                                                            {getVariantDetails(product_details).map((variant) => (
                                                                <span className="ps-cart-item__variant" key={`${variant.group_id}-${variant.item_id}`}>
                                                                    <span>{variant.group_name}</span>
                                                                    <strong>{variant.item_value || variant.item_name}</strong>
                                                                </span>
                                                            ))}
                                                        </Link>
                                                    ) : product_details.variant_name ? (
                                                        <Link className="ps-cart-item__variants" to={getProductLink(product_details)}>
                                                            <span className="ps-cart-item__variant">
                                                                <strong>{product_details.variant_name}</strong>
                                                            </span>
                                                        </Link>
                                                    ) : product_details.sku ? (
                                                        <span className="ps-cart-item__sku">SKU: {product_details.sku}</span>
                                                    ) : null}
                                                </div>
                                            </div>

                                            <div className="ps-cart-item__cell ps-cart-item__priceBlock">
                                                <span className="ps-cart-item__label">Price</span>
                                                <div className="ps-cart-item__price">&#8377;{money(product_details.offer_unit_price || product_details.offer_price)}</div>
                                                {Number(product_details.mrp || 0) > Number(product_details.offer_unit_price || product_details.offer_price || 0) ? (
                                                    <div className="ps-cart-item__strike">&#8377;{money(product_details.mrp)}</div>
                                                ) : null}
                                            </div>

                                            <div className="ps-cart-item__cell ps-cart-item__qtyBlock">
                                                <span className="ps-cart-item__label">Quantity</span>
                                                <div className="ps-cart-qty" role="group" aria-label={`${product_details.product_name} quantity`}>
                                                    <button type="button" className="ps-cart-qty__btn" disabled={this.state.messagesUpdating} onClick={()=>this.updateCart('D', product_details.cart_id)} aria-label={`Decrease ${product_details.product_name} quantity`}>-</button>
                                                    <span className="ps-cart-qty__value" aria-live="polite">{product_details.quantity}</span>
                                                    <button type="button" className="ps-cart-qty__btn" disabled={this.state.messagesUpdating} onClick={()=>this.updateCart('I', product_details.cart_id)} aria-label={`Increase ${product_details.product_name} quantity`}>+</button>
                                                </div>
                                            </div>

                                            <div className="ps-cart-item__cell ps-cart-item__totalBlock">
                                                <span className="ps-cart-item__label">Total</span>
                                                <div className="ps-cart-item__total">&#8377;{money(product_details.line_total || product_details.total_price)}</div>
                                            </div>

                                            <button
                                                type="button"
                                                className="ps-cart-item__remove"
                                                disabled={this.state.messagesUpdating}
                                                onClick={()=>this.localremovewishlist(product_details.cart_id)}
                                                aria-label={`Remove ${product_details.product_name}`}
                                            >
                                                <svg width="18" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false"><path d="M3 6h18M9 6V3h6v3M5 6l1 15h12l1-15M10 10v7m4-7v7" /></svg>
                                            </button>
                                        </article>
                                    ))}
                                    {group.promotionIds.length > 0 && <RewardOffers quote={rewardQuoteFor(this.state.promotionQuote,group.promotionIds)} onSelect={this.selectReward} busy={this.state.messagesUpdating} embedded/>}
                                    </section>)}
                                    <PromotionBenefits quote={remainingNotices} busy={this.state.messagesUpdating} showRewards={false} showChoices={false}/>
                                    <RewardOffers quote={rewardQuoteFor(this.state.promotionQuote,unassigned)} onSelect={this.selectReward} busy={this.state.messagesUpdating}/>
                                </section>

                                <aside className="ps-cart-summary">
                                    <div className="ps-cart-summary__card">
                                        <div className="nw-cart__summary-heading"><span className="nw-cart__summary-kicker">Ready when you are</span><h2 className="ps-cart-summary__title">Order summary</h2></div>
                                        <div className="ps-cart-summary__row">
                                            <span>Sub total</span>
                                            <strong>&#8377; {money(totalBox.sub_total_cart_value)}</strong>
                                        </div>
                                        {Number(totalBox.total_discount || 0) > 0 ? (
                                            <div className="ps-cart-summary__row nw-cart__discount">
                                                <span>Discount</span>
                                                <strong>- &#8377; {money(totalBox.total_discount)}</strong>
                                            </div>
                                        ) : null}
                                        <div className="ps-cart-summary__row">
                                            <span>Delivery charges</span>
                                            <strong>Calculated at checkout</strong>
                                        </div>
                                        {this.renderCartMessages()}
                                        <div className="ps-cart-summary__row ps-cart-summary__row--total">
                                            <span>Total</span>
                                            <strong>&#8377; {money(grandTotal)}</strong>
                                        </div>
                                        {Number(totalBox.total_discount || 0) > 0 && <p className="nw-cart__savings">You save &#8377;{money(totalBox.total_discount)} on this order</p>}
                                        {this.state.messagesUpdating ? (
                                            <button type="button" disabled className="ps-cart-summary__checkout ps-btn ps-btn--sm">
                                                Updating cart…
                                            </button>
                                        ) : (
                                            <Link className="ps-cart-summary__checkout ps-btn ps-btn--sm" to={{pathname:'/checkout', state:{rewardSelections:this.state.rewardSelections, rewardCartKey:rewardCartKey(this.state.wishlist, this.state.cartCountryId)}}}>Checkout</Link>
                                        )}
                                        <Link className="ps-cart-summary__continue" to="/">Continue shopping</Link>
                                        <p className="nw-cart__checkout-note">Delivery options and final charges are shown at checkout.</p>
                                    </div>
                                </aside>
                            </div>
                        ) : (
                            <div className="ps-cart-empty">
                                <div className="ps-cart-empty__content">
                                    <div className="nw-cart__empty-icon" aria-hidden="true">
                                        <svg viewBox="0 0 96 104" fill="none" focusable="false"><path d="M20 34h56l6 58H14l6-58Z" fill="#f3ead7" stroke="#ac8c59" strokeWidth="1.7" strokeLinejoin="round" /><path d="M34 40V25a14 14 0 0 1 28 0v15" stroke="#244b35" strokeWidth="2.5" strokeLinecap="round" /><path d="M47 77V54m0 12C34 66 32 56 34 51c10 0 15 7 13 15Zm1-5c0-12 8-17 17-16 0 11-8 17-17 16Z" stroke="#47684c" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" /></svg>
                                    </div>
                                    <span className="ps-cart__eyebrow">Make room for goodness</span>
                                    <h3>Your cart is empty</h3>
                                    <p>Find your everyday favourites, from traditional oils to pantry essentials.</p>
                                    <div className="ps-cart-empty__actions">
                                        <Link to="/" className="ps-cart-empty__button" data-abc="true">Start shopping</Link>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                <NotificationContainer/>
            </div>
        );
    }
}

export default Cart;
